import styled from 'styled-components'

export default styled.button`
  cursor: pointer;
  background: ${props => props.background ? props.background : '#e2813b'};
  color: ${props => props.color ? props.color : 'white'};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  border-radius: 3px;
  border: none;
  position: relative;
  font-family: 'Open Sans';
  &:disabled {
    background: #dddddd;
    cursor: default ;
  }
`
